import { render, staticRenderFns } from "./studyTask.vue?vue&type=template&id=acaa98bc&scoped=true"
import script from "./studyTask.vue?vue&type=script&lang=js"
export * from "./studyTask.vue?vue&type=script&lang=js"
import style0 from "./studyTask.vue?vue&type=style&index=0&id=acaa98bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaa98bc",
  null
  
)

export default component.exports